module.exports = "/_next/static/images/office-gray-icon-9ddbf23dc69964bcb6d9e5343a9a22ec.svg";